
import { get, post, put, destroy } from "./base";

const DeliveryAddresses = {
  index: (params) => get("/users/address", { params }),
  single: (id) => get(`/users/address/${id}`), // Not strictly needed as index returns list
  create: (payload) => post("/users/address", payload),
  update: (id, payload) => put(`/users/address/${id}`, payload),
  remove: (id) => destroy(`/users/address/${id}`),
};

export default DeliveryAddresses;
